import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const SupportHeader: React.FC = () => {
  const navItems: NavItem[] = [
    { icon: JobQueueIcon, label: 'Job Queue', path: '/support/job-queue' },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/support/profile"
      basePath="/support"
    />
  );
};

export default SupportHeader;
